"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVITY_ACTOR_KINDS = exports.ACTIVITY_EVENT_DOMAINS = void 0;
exports.ACTIVITY_EVENT_DOMAINS = ['report', 'crm'];
exports.ACTIVITY_ACTOR_KINDS = [
    'human',
    'system',
    'customer',
    'integration',
    'unknown',
];
